import React from "react";
import Select from "../Select";
import type { SelectOption } from "../Select";
import StatusDot from "../StatusDot";
import { StatusSelectContainer } from "./StatusSelect.styles";
import type { StatusSelectProps } from "./StatusSelect.types";

const StatusSelect: React.FC<StatusSelectProps> = ({
  options,
  value,
  onChange,
  ariaLabel = "Статус",
  disabled = false,
}) => {
  const selected = options.find((option) => Object.is(option.value, value));
  const selectOptions: SelectOption[] = options.map(({ label, value: optionValue, disabled: optionDisabled }) => ({
    label,
    value: optionValue,
    disabled: optionDisabled,
  }));

  return (
    <StatusSelectContainer>
      <StatusDot tone={selected?.tone || "inactive"} />
      <Select
        options={selectOptions}
        value={value}
        onChange={onChange}
        ariaLabel={ariaLabel}
        disabled={disabled}
        minWidth="104px"
        renderOptionPrefix={(option) => {
          const statusOption = options.find((item) => Object.is(item.value, option.value));
          return <StatusDot tone={statusOption?.tone || "inactive"} />;
        }}
      />
    </StatusSelectContainer>
  );
};

export default StatusSelect;
